import { useTranslation } from 'react-i18next';
import {
  Box,
  Chip,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { equalsIgnoringCase } from '../../../../../utils/stringUtils';
// import { downloadBlobFile } from '../../../../../utils/fileUtils';
// import { v4 as uuidv4 } from 'uuid';
import reportApi from '../../../../../services/api/ReportApi';
import { LoadingButton } from '@mui/lab';
import { useState } from 'react';

const TaskCompletionActions = ({ task }) => {
  const { t } = useTranslation();
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    if (task.result?.transactionLogID) {
      console.log('Starting download for transactionLogID:', task.result);
      try {
        setIsDownloading(true);
        reportApi.downloadTransactionOutputNew(task.result?.transactionLogID);
        // const { fileName, data } = await reportApi.downloadTransactionOutputNew(task.result?.transactionLogID);
        // console.log('Downloaded fileName:', fileName);
        // console.log('Downloaded data:', data);
        // if (data) {
        //   downloadBlobFile(fileName ?? uuidv4(), data);
        // }

        setIsDownloading(false);
      } catch (error) {
        setIsDownloading(false);
      }
    }
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
      {equalsIgnoringCase(task.result?.operation, 'Download') && (
        <LoadingButton
          variant="outlined"
          onClick={handleDownload}
          startIcon={<DownloadIcon color="primary" fontSize="small" />}
          loading={isDownloading}
          loadingPosition="start"
        >
          {t('Btn_Download')}
        </LoadingButton>
      )}

      {task.result?.message && (
        <Chip
          label={task.result.message}
          size="small"
          variant="outlined"
          color="info"
        />
      )}
    </Box>
  );
};

export default TaskCompletionActions;
